import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "clone",
  "use": "clone-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"clone\"><path d=\"M10.75 0a2.75 2.75 0 012.75 2.75V4h1.25a2.75 2.75 0 012.75 2.75v8a2.75 2.75 0 01-2.75 2.75h-8A2.75 2.75 0 014 14.75V13.5H2.75A2.75 2.75 0 010 10.75v-8A2.75 2.75 0 012.75 0h8zm2.75 10.75a2.75 2.75 0 01-2.75 2.75H5.5v1.25A1.25 1.25 0 006.75 16h8A1.25 1.25 0 0016 14.75v-8a1.25 1.25 0 00-1.25-1.25H13.5v5.25zM2.75 1.5A1.25 1.25 0 001.5 2.75v8A1.25 1.25 0 002.75 12h8A1.25 1.25 0 0012 10.75v-8a1.25 1.25 0 00-1.25-1.25h-8z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/clone.svg
// module id = 4iDW
// module chunks = 39 44